import { Icon, Typography } from '@data-products-and-ai/react-components';
import { IconType } from '@data-products-and-ai/react-components/lib/components/DataDisplay/Icon/Icon';
import { TypographyTags } from '@data-products-and-ai/react-components/lib/components/DataDisplay/Typography/types';
import { FC } from 'react';

import '@/components/LabeledIcon/LabeledIcon.scss';

interface LabeledIconProps {
  label: string;
  icon: IconType;
  tag?: TypographyTags;
}

export const LabeledIcon: FC<LabeledIconProps> = ({ label, icon, tag }) => {
  return (
    <div className="labeled-icon">
      <Icon color="var(--color-default)" icon={icon} iconSize={0.75} />
      <Typography {...(tag ? { tag } : {})} color="var(--color-neutral)">
        {label}
      </Typography>
    </div>
  );
};
